<template lang="pug">
div
  el-card(shadow="hover").card-container
    app-divider(label="Dados do VTN: ", :addMarginTop="false").margin-bottom
    div.center
      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Data Emissão:", :required="required")
          el-date-picker(
            style="width: 15vw"
            format="dd/MM/yyyy"
            v-model="emissaoDar.dataEmissao"
            :disabled="isAcusarEntrega"
            @change="$emit('atualizarData', emissaoDar.dataEmissao)"
          )

        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Valor da Parcela:", :required="required")
          app-double-input.appInput(
            name='Valor da Parcela',
            :precision="2",
            prefix='R$ ',
            :disable="disable"
            :onkeypress="onlyInputNumbers",
            v-model="valorParcela"
          )

        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Valor Total do DAR:", :required="required")
          app-double-input.appInput(
            name='Valor Total do DAR',
            :precision="2",
            prefix='R$ ',
            :disable="disable"
            :onkeypress="onlyInputNumbers",
            v-model="emissaoDar.valorTotalDar"
          )

      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Data Vencimento:", :required="required")
          el-date-picker(
            style="width: 15vw"
            format="dd/MM/yyyy"
            v-model="emissaoDar.dataVencimento"
            :disabled="isAcusarEntrega"
          )

        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Total de Juros:", :required="required")
          app-double-input.appInput(
            name='Total de Juros',
            :precision="2",
            prefix='R$ ',
            :disable="disable"
            :onkeypress="onlyInputNumbers",
            v-model="emissaoDar.totalJuros"
          )

      el-col(:span='16')
        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Número do DAR:", :required="required")
          el-input(
            v-model="emissaoDar.numeroDar"
            @change="$emit('atualizaNumeroDar', emissaoDar.numeroDar)"
            :disabled="isAcusarEntrega"
          )

        el-row.flexRow(:gutter="16")
          app-label.appLabel(label="Total de Correção Anual:", :required="required")
          app-double-input.appInput(
            name='Total de Correção Anual',
            :precision="2",
            prefix='R$ ',
            :disable="disable"
            :onkeypress="onlyInputNumbers",
            v-model="emissaoDar.totalCorrecaoAnual"
          )

    app-label.appLabel(:label='isAcusarEntrega ? "Upload do Comprovante:" : "Upload do Boleto:"', :required="required")
    el-card.card-container(shadow="hover")
      app-anexo(
        :id="'upload-atualizacao-base'"
        @uploadFile="uploadFile",
        :files="anexos",
        @removeFile="removeFile"
        @downloadDocumentoCadastro="downloadDocumentoCadastro"
        :fileType="fileType"
      )
</template>

<script>
import { mapActions } from 'vuex'
import axios from '@/utils/api'
import FileSaver from 'file-saver'
import AppUploadDocumentos from '@/components/AppUploadDocumentos.vue'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel.vue'
import AppDoubleInput from '@/components/AppDoubleInput.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay.vue'
import AppResumable from '@/components/AppResumable'
import AppAnexo from '@/components/AppAnexo'

export default {
  mixins: [onlyInputNumbers,
    AppNotificacao],

  components: {
    AppDivider,
    AppDisplay,
    AppLabel,
    AppDoubleInput,
    AppUploadDocumentos,
    AppResumable,
    AppAnexo
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    scope: {
      type: String,
      required: false
    },
    fileType: {
      type: Array,
      required: false,
      default: () => ['pdf', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'zip']
    },
    isAcusarEntrega: {
      type: Boolean,
      required: false,
      default: false
    },
    parcela: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      disable: true,
      anexos: [],
      emissaoDar: {
        valorParcela: '',
        valorTotalDar: '',
        dataVencimento: '',
        totalJuros: '',
        numeroDar: '',
        totalCorrecaoAnual: '',
        dataEmissao: new Date()
      }
    }
  },

  computed: {
    valorParcela () {
      return this.parcela.valor - this.parcela.juros - this.parcela.correcao
    }
  },

  mounted () {
    this.emissaoDar = {
      ...this.emissaoDar,
      dataVencimento: new Date(this.parcela.dataVencimento[0], this.parcela.dataVencimento[1] - 1, this.parcela.dataVencimento[2]),
      totalJuros: this.parcela.juros,
      totalCorrecaoAnual: this.parcela.correcao,
      valorTotalDar: this.parcela.valor,
      numeroDar: this.isAcusarEntrega ? this.parcela.boleto.numeroDar : ''
    }
  },

  methods: {
    ...mapActions({
      salvarBoleto: 'documento/salvarBoleto'
    }),

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            }).then(() => {
              this.deleteAnexo(documento)
            }).catch(() => {
              this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                'Houve um erro ao remover o anexo.')
            })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => { })
    },

    uploadFile (file) {
      this.anexos = []
      this.anexos.push({
        key: file.response,
        nome: file.name
      })
      this.$emit('uploadFile', this.anexos)
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(this.anexos.find(a => a.id === documento.id))
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(this.anexos.find(a => a.key === documento.key))
        this.anexos.splice(index, 1)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 7%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.el-row {
  margin-bottom: 20px;
}

.flexRow {
  display: flex;
}

.appLabel {
  flex: 1;
}

.appUpload {
  margin: 20px;
  border-radius: 10px;
  background-color: gainsboro;
  height: 95px;
}

.appInput {
  flex: 2;
}

.el-input__inner {
  border-radius: 4px;
  font-size: 14px;
}

.el-input-group__append {
  color: $--color-text-regular
}

.textUpload {
  display: flex;
  justify-content: space-around;
  padding-top: 33px;
  height: 95px;
}

.el-input {
  width: 15.5vw;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/InformacoesEmissaoDar.vue